import React, { ReactElement } from 'react';

import { observer } from 'mobx-react';
import { Link } from '@infoods/lifebase-ui';

import {
  GridTableCell,
  GridTableRow,
  UserInfoCell,
} from '../../../../../shared/components/table-components';
import { PreRegisteredInfo } from '../../../../interfaces/PreRegisteredRowInfo';
import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import { localDateTimeFormat } from '../../../../../shared/constants/apiDateFormat';
import {
  PRE_REGISTERED_COLUMN,
  PreRegisteredColumn,
} from '../PreRegisteredTable.settings';

type PreRegisteredRowProps = {
  customer: PreRegisteredInfo;
  visibleColumns: PreRegisteredColumn[];
};

const PreRegisteredRow = observer(
  ({ customer, visibleColumns }: PreRegisteredRowProps) => {
    const { id, firstName, lastName, email, coach, dateOfUpdate } = customer;

    const renderColumnsInfo: Record<PreRegisteredColumn, ReactElement> = {
      [PRE_REGISTERED_COLUMN.NAME]: (
        <UserInfoCell
          firstName={firstName}
          lastName={lastName}
          email={email}
          href={`#!/customer-setup/flow-2024/${id}`}
        />
      ),
      [PRE_REGISTERED_COLUMN.COACH]: (
        <GridTableCell>
          <Link href={`#!/nutrition/coach-edit/${coach.id}`}>
            {coach.firstName} {coach.lastName}
          </Link>
        </GridTableCell>
      ),
      [PRE_REGISTERED_COLUMN.DATE_OF_UPDATE]: (
        <GridTableCell justify="end">
          {getFormattedDate(dateOfUpdate, localDateTimeFormat)}
        </GridTableCell>
      ),
    };

    return (
      <GridTableRow variant="subRow">
        {visibleColumns.map((column) => (
          <React.Fragment key={column}>{renderColumnsInfo[column]}</React.Fragment>
        ))}
      </GridTableRow>
    );
  },
);

export { PreRegisteredRow };
